import React from 'react';
import Header from '../Header/Header';
import './Home.css'
import actionBox from '../../../image/actionBox.svg'

const Home = () => {
    return (
        
        <div className="mx-0 px-0 bg-class bg-left bg-right">
            <Header></Header>
        </div>
    );
};

export default Home;